// Stage cards — labels & subtitles taken from the mockup. Shared by the
// onboarding flow and the update-profile form so both render the same set.
// The real stage id comes from the API; we match on name.
export const STAGE_META = [
  { key: 'pre-seed', title: 'Pre-Seed', subtitle: 'Ideation stage' },
  { key: 'seed', title: 'Seed', subtitle: 'Product development' },
  { key: 'seed-plus', title: 'Seed+', subtitle: 'Product market fit' },
  { key: 'growth', title: 'Growth', subtitle: 'Scaling up' },
  { key: 'expansion', title: 'Expansion', subtitle: 'IPO readiness' },
];

// Whitespace and hyphens vary between the API ("Seed +", "Pre-Seed") and the
// mockup labels ("Seed+", "Pre-Seed"); "+" is significant and must be kept, or
// "Seed +" collapses onto "Seed".
const normalize = (name) =>
  String(name || '')
    .toLowerCase()
    .replace(/[\s-]/g, '');

export const findStageMeta = (name) => {
  const target = normalize(name);
  if (!target) return undefined;
  return STAGE_META.find((meta) => normalize(meta.title) === target);
};
